import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@workos-inc/authkit-react";
import { Box, CircularProgress } from "@mui/material";

interface RequirePermissionProps {
  permission: string;
  children: React.ReactNode;
}

export function RequirePermission({
  permission,
  children,
}: RequirePermissionProps) {
  const { isLoading, permissions } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!permissions.includes(permission)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
